// Autrona Acoustic Computer Program: Pluie
// Une première expérience

import * as main from '../main.js';
import * as screen from '../kernel/screen.js';
import * as audio from '../kernel/audio.js';

export { init, run, exit }

// Variables
let userName;

// Références à loops audio
const oneShots = [];
const loops = {};
let timeout;
let exitCallback;

// Niveaux Audio en décibels
//   0 db = unité = volume maximal
//   -90 db = volume à ~zéro
const audioLevels = {
    // Niveaux absolus initiaux ou post fade-in
    'background':          -3,
    'foret':                0,
    'branches':             0,
    'pelle':              -12,
    'riviere':              0,
    'autoroute':           -2,
    'voiture-arrive':       0,
    'radio-loin':          -5,
    'course-mort':          0,
    'course-mort-rev':     -6,
    'attente-cigarette':   -6,
    'attente-vaporette':   -6,
    'voiture-entree':       0,
    'pas':                 -8,
    'fin-jazz':             0,
    'fin-electro':          0,

    // Attenuations
    'attenuation-attente':  -12,
    'attenuation-voiture':  -90,
}

// Initialize module
function init() {
}

function run(exitCb) {
    exitCallback = exitCb;
    prompt = ''; // Reset
    resetScreen();

    main.soundEffect('validate');

    timeout = setTimeout(() => {
        // Screen sequence. See screen.js comments for documentation
        const seq = `
            §3000 Votre num §§§om ?
            `;
        screen.sequence2(seq.trim(), {
            /* Sequence options */
            color: 'col-green',
            lead: 'Nar-6> ',
            teletypeDelay: 'human',
        }, () => {
            screen.askText(null, passageA);
        });
    }, 2000);
}

function resetScreen() {
    screen.clear();
    screen.insert('AutronaTerm v2.5 - 802.11', 'col-red', 'col-bg-red');
    screen.pinCurrentLine();
}

function passageA(answer) {
    userName = answer;

    const seq = `
        §2000 Souvenez-vous...
        §5000 Souvenez-vous.
        
        §5000 Je sais que vous avez déjà vécu ça.
        §5000 Comment les événements s’étaient-ils enchaînés ?
        
        §7000 Vous étiez en forêt.
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, passageA1);
}

function passageA1() {
    loops.foret = audio.buffers.play('foret', {
        loop: true,
        loopStart: 1.0,
        loopEnd: 50.116,
    }).fadeTo(10, audioLevels['foret']);

    const seq = `
        §24000 Vous marchiez.
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: '',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, passageA2);
}

function passageA2() {
    loops.branches = audio.buffers.play('branches', {
        loop: true,
    }).fadeTo(1, audioLevels['branches']);

    timeout = setTimeout(() => {
        loops.pelle = audio.buffers.play('pelle', {
            loop: true,
        }).fadeTo(15, audioLevels['pelle']);
    }, 20000);

    const seq = `
        §31000 Stop. Vous entendez ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: '',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, passageA3);
}

function passageA3() {
    loops.branches.fade(1, -90, true);

    const seq = `
        §10000 Ecoutez bien.
        §2000 Que fabrique-t-il ?
        
        §15000 Je suis sûr que vous vous en souvenez.
        §4000 C’est là que tout a commencé !
        
        §2000 Souvenez-vous...
        §5000 Que fabrique-t-il ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: '',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Ben... Je sais pas trop.', passageB],
            '2': ['Heu... Je vois rien.', passageC],
        });
    });
}

function passageB() {
    const seq = `
        §3000 On m’a dit que vous aviez l’oreille fine...
        Est-ce une sévère perte de mémoire ou un simple oubli ?
        
        §10000 Allez. dites-moi...
        
        §5000 Où se trouve-t-il ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
        endDelay: 3000,
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Au bord d’une rivière ?', passageD],
            '2': ['A moins que ce soit près de l’autoroute...', passageE],
        });
    });
}

function passageC() {
    const seq = `
        §2000 Et moi ?
        Vous croyez que je vois quelque chose ?
        Vous êtes mes oreilles !
        
        §3000 Et ce sont vos souvenirs !

        §3000 Allez. dites-moi...
        
        §5000 Où se trouve-t-il ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
        endDelay: 3000,
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Heu... disons près d’une autoroute. ', passageE],
            '2': ['Ou peut-être à côté de la rivière ?', passageD],
        });
    });
}

function passageD() {
    loops.riviere = audio.buffers.play('riviere', {
        loop: true,
    }).fadeTo(1.0, audioLevels['riviere']);

    const seq = `
        §2000 Bravo !
        
        Alors vous voyez... §1000 vous êtes comme un démiurge !
        Les sons sont votre spécialité... §1000 la musique... §1000 l’enchaînement des bruits... §1000 une symphonie qui court sur la rivière...
        
        §10000 Ne me dites pas que vous avez une mémoire visuelle !
        On risque de mal s’entendre.
        
        §5000 Bon, alors.
        §2000 Que fabrique-t-il ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Je crois qu’il faisait juste des exercices physiques.', passageF],
            '2': ['Peut-être qu’il creuse ?', passageG],
        });
    });
}

function passageE() {
    loops.autoroute = audio.buffers.play('autoroute', {
        loop: true,
    }).fadeTo(1.0, audioLevels['autoroute']);

    const seq = `
        §2000 Bravo !
        
        §4000 Alors vous voyez... vous êtes comme un dieu créateur !

        Les sons sont votre spécialité... la musique... l’enchaînement des bruits...
        Une symphonie qui roule comme des voitures sur une autoroute...
        
        §10000 Ne me dites pas que vous avez une mémoire visuelle !
        On risque de mal s’entendre.
        
        §5000 Bon, alors.
        §2000 Que fabrique-t-il ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Je crois qu’il faisait juste des exercices physiques.', passageF],
            '2': ['Peut-être qu’il creuse ?', passageG],
        });
    });
}

function passageF() {
    const seq = `
        §2000 Wha§1000§§§Non ${userName} !
        Il ne faisait pas juste des exercices physiques...
        
        §8000 Vous croyez que tout ça n’est qu’un jeu ?
        §3000 Que vous pouvez choisir comme bon vous semble ?
        
        §5000 Concentrez-vous un peu !
        Alors ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Alors... il creuse ! ', passageG],
        });
    });
}

function passageG() {
    const seq = `
        §3000 Très juste... §2000 en effet.
        Il creuse.
        
        §5000 Il creuse pour enterrer... §2000 quelque chose.
        
        §8000 Et je crois que ça vous effraie.
        Avait-il une arme ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        screen.choice('', {
            '1': ['Il me semble que oui.', passageH],
            '2': ['Ca fait très série B !', passageH2],
        });
    });
}

function passageH() {
    const seq = `
        §2000 Vous n'êtes pas sûr ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, () => {
        /* Sequence callback */
        passageHI();
    });
}

function passageH2() {
    const seq = `
        §2000 Trêve de plaisanterie ${userName} !
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, () => {
        /* Sequence callback */
        passageHI();
    });
}

function passageHI() {
    const seq = `
        §3000 Vous avez au moins le souvenir d’avoir trouvé cet individu très dangereux...
        Il vous faudra fuir à la moindre occasion !
        
        §4000 Attendez ! Chut ! Taisez-vous !
        Une voiture arrive...
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: '',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, () => {
        /* Sequence callback */
        screen.insert('', 'col-green')
        screen.dots();
        oneShots.push(audio.buffers.play('voiture-arrive', {
        onended: passageHI2
        }).fadeTo(4.0, audioLevels['voiture-arrive']));
    });
}

function passageHI2() {
    loops.radioLoin = audio.buffers.play('radio-loin', {
        loop: true,
    }).fadeTo(1.0, audioLevels['radio-loin']);

    const seq = `
        §2000 Etrange.
        La portière est restée ouverte.
        On entend d’ici l’autoradio.

        Vous êtes à quelques mètres de la voiture mais...
        §3000 Y avait-il vraiment quelqu'un au volant ?
        
        §5000 Et pourquoi l’autre continue de creuser ?
        Votre mémoire est floue ${userName}.
        
        §5000 Cette voiture vous attire. Que faites-vous ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: '',
        teletypeDelay: 'human',
        newLineAtStart: false,
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Je cours vers la voiture pour la voler et m’enfuir !', passageK],
            '2': ['J’attends un moment plus propice.  ', passageJ],
        });
    });
}

function passageJ() {
    const seq = `
        §3000 La prudence était votre boussole... §1000 c’est bien.
        
        §3000 Vous êtes sage... §1000 raisonnable.
        Vous attendez donc.
        
        §4000 Ça risque de durer quelques minutes...
        
        §4000 Une cigarette ?
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Oui, une clope, avec plaisir !', passageL2],
            '2': ['Pourquoi pas. Mais seulement une e-cigarette.', passageL1],
        });
    });
}

function passageK() {
    loops.courseMort = audio.buffers.play('course-mort', {
        loop: true,
        loopStart: 20.0,
        loopEnd: 24.105,
    }).fadeTo(2, audioLevels['course-mort']);

    setTimeout(() => {
        loops.pelle.fade(1);
        loops.foret.fade(1);
        if (loops.riviere) loops.riviere.fade(1);
        if (loops.autoroute) loops.autoroute.fade(1);
        loops.radioLoin.fade(1);
    }, 7000); // Coup de feu à 7 secondes

    screen.newLine();
    screen.insert('Vous courez vers la voiture', 'col-light-gray', 'italic');
    screen.dots();

    timeout = setTimeout(() => {
        const seq = `
            §1000 La mort ?
            
            §3000 Déjà ? §4000 Vous êtes sûr ?
            
            §3000 Non ça ne doit pas être ça...
            `;
        screen.sequence2(seq.trim(), {
            /* Sequence options */
            color: 'col-green',
            lead: 'Nar-6> ',
            teletypeDelay: 'human',
        }, () => {
            /* Sequence callback */
            screen.choice('', {
                '1': ['Revenir en arrière', passageK2],
            });
        });
    }, 18000);
}

function passageK2() {
    loops.courseMort.fade(1, -90, true);
    oneShots.push(audio.buffers.play('course-mort-rev', {
        onended: passageK3
    }).fadeTo(1, audioLevels['course-mort-rev']));
}

function passageK3() {
    loops.pelle.fadeTo(1, audioLevels['pelle']);
    loops.foret.fadeTo(1, audioLevels['foret']);
    if (loops.riviere) loops.riviere.fadeTo(1, audioLevels['riviere']);
    if (loops.autoroute) loops.autoroute.fadeTo(1, audioLevels['autoroute']);
    loops.radioLoin.fadeTo(1, audioLevels['radio-loin']);

    const seq = `
        §2000 Vous êtiez à quelques mètres de la voiture.
        Elle semble être venue pour vous, mais...
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['J’attends un moment plus propice.', passageJ],
        });
    });
}

function passageL1() {
    // Fade out to pause
    loops.pelle.fade(2, audioLevels['attenuation-attente']);
    loops.foret.fade(2, audioLevels['attenuation-attente']);
    if (loops.riviere) loops.riviere.fade(2, audioLevels['attenuation-attente']);
    if (loops.autoroute) loops.autoroute.fade(2, audioLevels['attenuation-attente']);
    loops.radioLoin.fade(2, audioLevels['attenuation-attente']);

    loops.attenteVaporette = audio.buffers.play('attente-vaporette', {
        initialGain: audioLevels['attente-vaporette'],
        when: 2,
        loop: true,
        loopStart: 5.0,
        loopEnd: 28.0,
        onended: passageL,
    });

    screen.newLine();
    screen.insert('Vous utilisez une e-cigarette', 'col-light-gray', 'italic');
    screen.dots();

    timeout = setTimeout(() => {
        screen.newLine();
        screen.choice('', {
            '1': ['Arreter de vapoter', () => {
                loops.attenteVaporette.fade(2, -90, true);
            }],
        });
    }, 3000);
}

function passageL2() {
    // Fade out to pause
    loops.pelle.fade(2, audioLevels['attenuation-attente']);
    loops.foret.fade(2, audioLevels['attenuation-attente']);
    if (loops.riviere) loops.riviere.fade(2, audioLevels['attenuation-attente']);
    if (loops.autoroute) loops.autoroute.fade(2, audioLevels['attenuation-attente']);
    loops.radioLoin.fade(2, audioLevels['attenuation-attente']);

    loops.attenteCigarette = audio.buffers.play('attente-cigarette', {
        initialGain: audioLevels['attente-cigarette'],
        when: 2,
        loop: true,
        loopStart: 1.0,
        loopEnd: 11.5,
        onended: passageL,
    });

    screen.newLine();
    screen.insert('Vous fumez une cigarette', 'col-light-gray', 'italic');
    screen.dots();

    timeout = setTimeout(() => {
        screen.newLine();
        screen.choice('', {
            '1': ['Eteindre la cigarette', () => {
                loops.attenteCigarette.loop = false;
            }],
        });
    }, 3000);
}

function passageL() {
    // Fade back in from pause
    loops.foret.fadeTo(2, audioLevels['foret']);
    if (loops.riviere) loops.riviere.fadeTo(2, audioLevels['riviere']);
    if (loops.autoroute) loops.autoroute.fadeTo(2, audioLevels['autoroute']);
    loops.radioLoin.fadeTo(2, audioLevels['radio-loin']);

    loops.pelle.fade(1, -90, true);

    const seq = `
        §2000 Vous êtes toujours là ?
        
        §3000 Ecoutez !
        §4000 Il n’y a plus personne ?
        
        §8000 Le type qui creuse est parti...
        
        §4000 La voiture est toujours là... §1000 prête à l’emploi.
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        /* Sequence callback */
        screen.choice('', {
            '1': ['Quand faut y aller, faut y aller !', passageM],
            '2': ['Partir à la recherche du type qui creusait ?', passageM2],
        });
    });
}

function passageM() {
    screen.newLine();
    screen.insert('Vous marchez vers la voiture', 'col-light-gray', 'italic');
    screen.dots();

    loops.radioLoin.fade(12, 6);

    oneShots.push(audio.buffers.play('pas', {
        initialGain: audioLevels['pas'],
        onended: () => {
            loops.voitureRadio = audio.buffers.play('voiture-entree', {
                initialGain: audioLevels['voiture-entree'],
                loop: true,
                loopStart: 3.591,
                loopEnd: 16.5,
            });

            // Diminuer ou arrêter les sons
            loops.foret.fade(1, audioLevels['attenuation-voiture'], true);
            if (loops.riviere) loops.riviere.fade(1, audioLevels['attenuation-voiture'], true);
            if (loops.autoroute) loops.autoroute.fade(1, audioLevels['attenuation-voiture'], true);
            loops.radioLoin.fade(1, audioLevels['attenuation-voiture'], true);

            const seq = `
                §2000 Vous voilà dans la voiture.
                Vous vous en souvenez ?

                §2000 La radio baragouinait des inepties contemporaines...
                Y avait comme un bug.
                
                §2000 Vous vous en souvenez ?
            `;
            screen.sequence2(seq.trim(), {
                /* Sequence options */
                color: 'col-green',
                lead: 'Nar-6> ',
                teletypeDelay: 'human',
            }, () => {
                /* Sequence callback */
                screen.choice('', {
                    '1': ['Taper sur la gauche de la radio', passageN1],
                    '2': ['Taper sur la droite de la radio', passageN2],
                });
            });
        }
    }));
}

function passageM2() {
    screen.newLine();
    screen.insert('<Error: Memory address out of range>', 'col-dark-red', 'italic');

    main.soundEffect('error');

    timeout = setTimeout(() => {
        const seq = `
            §5000 Oups désolé, je crois qu'il y a une erreur
            Ces souvenirs ne sont pas accessibles...
            
            §3000 Peut-être faut-il attendre une mise à jour ?
            `;
        screen.sequence2(seq.trim(), {
            /* Sequence options */
            color: 'col-green',
            lead: 'Nar-6> ',
            teletypeDelay: 'human',
        }, () => {
            screen.choice('', {
                '1': ['Revenir au choix précédent', passageM3],
            })
        });
    }, 2000);
}

function passageM3() {
    const seq = `
        §2000 Donc le type qui creuse est parti.

        §2000 La voiture est toujours là... prête à l’emploi.
        `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
    }, () => {
        screen.choice('', {
            '1': ['Quand faut y aller, faut y aller !', passageM],
        })
    });
}

function passageN1() {
    screen.newLine();
    screen.insert('La radio diffuse de la musique', 'col-light-gray', 'italic');
    screen.dots();

    loops.voitureRadio.fade(1, -90, true);
    oneShots.push(audio.buffers.play('fin-jazz', {
        initialGain: audioLevels['fin-jazz'],
        onended: () => {
            exit();
        },
    }));
    timeout = setTimeout(passageO, 20000);
}

function passageN2() {
    screen.newLine();
    screen.insert('La radio diffuse de la musique', 'col-light-gray', 'italic');
    screen.dots();

    loops.voitureRadio.fade(1, -90, true);
    oneShots.push(audio.buffers.play('fin-electro', {
        initialGain: audioLevels['fin-electro'],
        onended: () => {
            exit();
        },
    }));
    timeout = setTimeout(passageO, 20000);
}

function passageO() {
    const seq = `
        §2000 Vous avez fui !
        
        §8000 Vous êtes en sécurité. 
        
        §8000 Au moins pour un moment...
        
        §8000 Vous êtes en route pour d’autres aventures,
        
        §8000 d’autres embranchements.

        §8000 Bientôt...
    `;
    screen.sequence2(seq.trim(), {
        /* Sequence options */
        color: 'col-green',
        lead: 'Nar-6> ',
        teletypeDelay: 'human',
        newLineAtEnd: false,
    }, () => {
        // timeout = setTimeout(() => {
        //     exit();
        // }, 8000);
    });
}

function stopAllSounds() {
    oneShots.forEach(source => source.stop());
    Object.values(loops).forEach(source => source.stop());
}

function exit() {
    stopAllSounds();
    screen.clear();
    exitCallback();
}
